import request from '@/utils/request'

let statisticalApi = {
  /*业务员列表*/
  salesmanlist(data, errorback) {
    return request._post('/shop/plus.statistical.index/index', data, errorback);
  },
  /*分销订单*/
  agentOrder(data, errorback) {
    return request._post('/shop/plus.statistical.index/orederList', data, errorback);
  },

}
export default statisticalApi;



// WEBPACK FOOTER //
// ./src/api/statistical.js